const translations = {
  en: {
    switchAccount: 'Switch account',
    footerText: '{brand} is one of the world’s first cryptocurrency exchanges that offers advanced ID verification and full KYC through official electronic ID solutions.',
    setPassword: 'Set password',
    setPasswordText: 'Please set a powerful password below',
    password: 'Password',
    repeatPassword: 'Repeat password',
    passwordValidate1: 'Password does not meet security requirements',
    passwordValidate2: 'Passwords do not match.',
    needHelp: 'Need help ?',
    descriptionPassword: 'Must be at least 8 characters, have at least one number, one uppercase letter, one lowercase letter, and one special character.',
    requiredField: 'This field is required.',
    verificationInProgress: "We're verifying your identity",
    verificationTime: 'This can take up to two minutes.',
    tryAgain: 'Please try again',
    cancel: 'Cancel',
    retry: 'Retry',
    successTitle: 'Success',
    successMessage: 'Your verification was successful - you will be redirected to the dashboard where you can login with your new account automatically.',
    redirectLinkMessage: "If the automatic redirect doesn't work please use this link to go to the dashboard.",
    readyToLoginTitle: "You're ready to login!",
    readyToLoginMessage: 'Your account has already been created and successfully verified.',
    visit: 'Visit',
    dashboardLink: 'our dashboard',
    ableToLoginMessage: 'where you will be able to login using your email and the password you have set.',
    countryErrorMessage: 'Verification failed. We currently do not support passports issued by the country - {countryName}',
    countryMessageForCheckError: 'Verification failed. We currently do not support passports issued by the country',
    timeOutErrorMessage: 'Verification failed or timed out',
    contactMessage: 'Contact {brandEmail} for support.',
  },
  es: {
    switchAccount: 'Cambiar de cuenta',
    footerText: '{brand} es uno de los primeros intercambios de criptomonedas en el mundo que ofrece verificación avanzada de ID y KYC completo a través de soluciones oficiales de ID electrónico.',
    setPassword: 'Establecer contraseña',
    setPasswordText: 'Introduzca una contraseña segura',
    password: 'Contraseña',
    repeatPassword: 'Repetir contraseña',
    passwordValidate1: 'La contraseña no cumple los requisitos de seguridad.',
    passwordValidate2: 'Las contraseñas no coinciden.',
    needHelp: '¿Necesitas ayuda?',
    descriptionPassword: 'Debe tener al menos 8 caracteres, un número, una mayúscula, una minúscula y un carácter especial.',
    requiredField: 'Este campo es obligatorio.',
    verificationInProgress: 'Estamos verificando tu identidad',
    verificationTime: 'Esto puede tardar hasta dos minutos.',
    tryAgain: 'Intenta de nuevo',
    cancel: 'Cancelar',
    retry: 'Reintentar',
    successTitle: 'Éxito',
    successMessage: 'Tu verificación fue exitosa - serás redirigido al panel donde podrás iniciar sesión automáticamente con tu nueva cuenta.',
    redirectLinkMessage: 'Si la redirección automática no funciona, utiliza este enlace para ir al panel.',
    readyToLoginTitle: '¡Estás listo para iniciar sesión!',
    readyToLoginMessage: 'Tu cuenta ya ha sido creada y verificada con éxito.',
    visit: 'Visita',
    dashboardLink: 'nuestro panel',
    ableToLoginMessage: 'donde podrás iniciar sesión usando tu correo electrónico y la contraseña que hayas configurado.',
    countryErrorMessage: 'Error en la verificación. Actualmente no admitimos pasaportes emitidos por el país - {countryName}',
    countryMessageForCheckError: 'Error en la verificación. Actualmente no admitimos pasaportes emitidos por el país',
    timeOutErrorMessage: 'La verificación falló o se agotó el tiempo',
    contactMessage: 'Comuníquese con {brandEmail} para obtener ayuda.',
  },
  pt: {
    switchAccount: 'Mudar de conta',
    footerText: '{brand} é uma das primeiras exchanges de criptomoedas do mundo que oferece verificação avançada de ID e KYC completo através de soluções oficiais de ID eletrônico.',
    setPassword: 'Definir palavra-passe',
    setPasswordText: 'Defina uma palavra-passe poderosa abaixo',
    password: 'Palavra-passe',
    repeatPassword: 'Repetir a palavra-passe',
    passwordValidate1: 'A palavra-passe não cumpre os requisitos de segurança.',
    passwordValidate2: 'As palavras-passe não coincidem.',
    needHelp: 'Precisa de ajuda?',
    descriptionPassword: 'Deve ter pelo menos 8 caracteres, conter pelo menos um número, uma letra maiúscula, uma letra minúscula e um carácter especial.',
    requiredField: 'Este campo é obrigatório.',
    verificationInProgress: 'Estamos verificando sua identidade',
    verificationTime: 'Isso pode levar até dois minutos.',
    tryAgain: 'Por favor, tente novamente',
    cancel: 'Cancelar',
    retry: 'Repetir',
    successTitle: 'Sucesso',
    successMessage: 'Sua verificação foi bem-sucedida - você será redirecionado para o painel onde poderá entrar automaticamente com sua nova conta.',
    redirectLinkMessage: 'Se o redirecionamento automático não funcionar, use este link para ir ao painel.',
    readyToLoginTitle: 'Você está pronto para entrar!',
    readyToLoginMessage: 'Sua conta já foi criada e verificada com sucesso.',
    visit: 'Visite',
    dashboardLink: 'nosso painel',
    ableToLoginMessage: 'onde você poderá entrar usando seu e-mail e a senha que definiu.',
    countryErrorMessage: 'A verificação falhou. Atualmente, não oferecemos suporte a passaportes emitidos pelo país - {countryName}',
    countryMessageForCheckError: 'A verificação falhou. Atualmente, não oferecemos suporte a passaportes emitidos pelo país',
    timeOutErrorMessage: 'A verificação falhou ou expirou',
    contactMessage: 'Entre em contato com {brandEmail} para obter suporte.',
  },
  et: {
    switchAccount: 'Vaheta kontot',
    footerText: '{brand} on üks maailma esimesi krüptoraha vahetusi, mis pakub täiustatud ID-kinnitust ja täielikku KYC-d ametlike elektroonilise ID lahenduste kaudu.',
    setPassword: 'Määra parool',
    setPasswordText: 'Määrake allpool võimas parool',
    password: 'Salasõna',
    repeatPassword: 'Korda parooli',
    passwordValidate1: 'Parool ei vasta turvanõuetele',
    passwordValidate2: 'Paroolid ei ühti.',
    needHelp: 'Vajad abi?',
    descriptionPassword: 'Peab koosnema vähemalt 8 tähemärgist, sisaldama vähemalt ühte numbrit, ühte suurtähte, ühte väiketähte ja ühte erimärki.',
    requiredField: 'See väli on kohustuslik.',
    verificationInProgress: 'Me kinnitame teie identiteeti',
    verificationTime: 'See võib võtta kuni kaks minutit.',
    tryAgain: 'Palun proovige uuesti',
    cancel: 'Tühista',
    retry: 'Proovi uuesti',
    successTitle: 'Edu',
    successMessage: 'Teie kinnitamine oli edukas - teid suunatakse automaatselt juhtpaneelile, kus saate oma uue kontoga sisse logida.',
    redirectLinkMessage: 'Kui automaatne ümbersuunamine ei tööta, kasutage juhtpaneelile minemiseks seda linki.',
    readyToLoginTitle: 'Olete valmis sisse logima!',
    readyToLoginMessage: 'Teie konto on juba loodud ja edukalt kinnitatud.',
    visit: 'Külastage',
    dashboardLink: 'meie juhtpaneeli',
    ableToLoginMessage: 'kus saate oma e-posti ja määratud parooliga sisse logida.',
    countryErrorMessage: 'Kinnitamine ebaõnnestus. Praegu me ei toeta riigi väljastatud passe - {countryName}',
    countryMessageForCheckError: 'Kinnitamine ebaõnnestus. Praegu me ei toeta riigi väljastatud passe',
    timeOutErrorMessage: 'Kinnitamine ebaõnnestus või aegus',
    contactMessage: 'Toe saamiseks võtke ühendust ettevõttega {brandEmail}',
  },
};

export const getTranslation = (key, params = {}) => {
  const language = navigator.language.startsWith('es') ? 'es' : navigator.language.startsWith('pt') ? 'pt' : 'en';

  let translation = translations[language][key];
  Object.keys(params).forEach(param => {
    translation = translation.replace(`{${param}}`, params[param]);
  });

  return translation;
};
